import axios from 'axiosConfig';

export const getAllActivityType = () => axios.get("/api/loanactivity/activitytype");

export const getAllLoanNumbers = () => axios.get("/api/loanactivity/getloannumbers");

export const getLoanActivityById = (loanMasterId) => axios.get(`/api/loanactivity/${loanMasterId}`);

export const getLastLoanActivitySummary = (payload) => axios.post("/api/loanactivity/lastsummary", payload);

export const addNewLoanActivity = (newLoanActivity) => axios.post("/api/loanactivity/add", newLoanActivity, {});